export default __webpack_public_path__ + "static/team-image-4-6c6e41efbf6ccea14631c2429dc5f015.png";